import { MdDevices, MdHub, MdInsights, MdSecurity } from 'react-icons/md';

const features = [
  { icon: <MdHub />, title: 'Connected by design', text: 'Products share a clear healthcare ecosystem while remaining practical as standalone tools.' },
  { icon: <MdDevices />, title: 'Built around real users', text: 'Focused experiences for hospital teams, pharmacy staff, administrators, and patients.' },
  { icon: <MdSecurity />, title: 'Trusted patient context', text: 'Hospium ID supports accurate identification and a safer path into connected services.' },
  { icon: <MdInsights />, title: 'Operational visibility', text: 'Structured workflows and reporting help owners understand and improve daily operations.' },
];

export default function FeaturesSection() {
  return (
    <section className="HospiumSection HospiumFeatures">
      <div className="container">
        <div className="HospiumSectionIntro">
          <span className="HospiumKicker">Designed for healthcare operations</span>
          <h2>Technology should make care easier to deliver</h2>
          <p>Hospium brings the essential parts of a patient journey into a coherent set of products without losing the flexibility each organization needs.</p>
        </div>
        <div className="row g-4">
          {features.map((feature) => (
            <div className="col-12 col-md-6 col-xl-3" key={feature.title}>
              <div className="HospiumFeatureCard">
                <div className="HospiumFeatureIcon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
